import {
  OnboardingResponse,
  ApiResponseBase,
  AuthenticateUserResponse,
} from './Onboarding.types';

export function verifyResponseType<T>(endpoint: string, actual: unknown, expected: OnboardingResponse[]): T {
  const handlers: { [key in OnboardingResponse]: () => boolean } = {
    ApiResponse: () => isApiResponse(actual),
    AuthenticateUserResponse: () => isAuthenticateUserResponse(actual),
    AlphaVantageResponse: () => isAlphaVantageResponse(),
  };

  if (!expected.some((possibleResType) => handlers[possibleResType]())) {
    throw new Error(`Did not receive the expected response type from ${endpoint}`);
  }

  return actual as T;
}

function isError(res: unknown): boolean {
  const hasErrorMessage = Object.prototype.hasOwnProperty.call(res, 'errorMessage');

  return isApiResponse(res) && !res.success && res.errorMessage !== '' && hasErrorMessage;
}
function isSuccess(res: unknown): boolean {
  return isApiResponse(res) && res.success && !res.errorMessage;
}

function isApiResponse(res: unknown): res is ApiResponseBase {
  const hasSuccess = Object.prototype.hasOwnProperty.call(res, 'success');
  const hasErrorMessage = Object.prototype.hasOwnProperty.call(res, 'errorMessage');

  return [hasSuccess, hasErrorMessage].some((condition) => condition);
}

function isAlphaVantageResponse() {
  return true;
}

function isAuthenticateUserResponse(res: unknown): res is AuthenticateUserResponse {
  const hasBearerToken = Object.prototype.hasOwnProperty.call(res, 'bearerToken');

  const hasAuthorization = isSuccess(res) && [hasBearerToken].every((condition) => condition);

  return hasAuthorization || isError(res);
}

